// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2e3sN","right":"styles_right__1gvxV"};